import { render, staticRenderFns } from "./Core.vue?vue&type=template&id=7449f018&scoped=true"
import script from "./Core.vue?vue&type=script&lang=js"
export * from "./Core.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449f018",
  null
  
)

export default component.exports